module.exports = __webpack_public_path__ + "img/bluetooth-off.a4455e26.svg";